/**
 * Landing lists, one per module's LANDING screen (L-0858 part b, Nick 2026-10-14: "the landing page of every module needs
 * to be warmed up so switching modules is instant"). hooks/useKeepWarm.ts keeps them warm the whole time the app is open
 * (L-0868), only for modules the signed-in user can open.
 *
 * Each list is the callables the landing screen INVOKES ON MOUNT, from a jest render trace of every module's landing
 * screen (drops/BH17-L0858-trace-landing.json: contexts mocked, data empty). So it is a LOWER BOUND: reads that fire
 * after rows load are not here. Not listed (named limits): forms, hr, huddle, insurance, investors, quoting, safety,
 * shop (the trace saw no mount callable) and support, technician, time (the screen did not render in the trace).
 * `fieldService_listGenerators` (held back for the L-0140 comparison) is left out of Field Service's landing list.
 */
export const WAKE_LANDING = {
  aiSystems: { enabled: true, callables: ['getAIFeedbackStats', 'getAIOutputStats', 'getPendingDeployments'] },
  billing: { enabled: true, callables: ['dataHub_listConnectionSummaries'] },
  crm: { enabled: true, callables: ['generateDailyActions'] },
  explorer: { enabled: true, callables: ['dataHub_listConnectionSummaries', 'getExecutiveFinancials', 'profitability_getJobs'] },
  fieldService: { enabled: true, callables: ['fieldService_needsAttention'] },
  fleet: { enabled: true, callables: ['dataHub_listConnectionSummaries'] },
  marketing: { enabled: true, callables: ['marketing_dispatch'] },
  projects: { enabled: true, callables: ['projects_listInstallInvoices'] },
  recruiting: { enabled: true, callables: ['recruiting_dispatch'] },
  workshop: { enabled: true, callables: ['resolveMyWorkshopTools'] },
} as const;
